import { useCallback, useState } from 'react';
import type { SyntheticEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { CATEGORIES } from './constants';

export const useAdminPanelManagementPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = useCallback((_: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  }, []);

  const handleNavigate = useCallback(
    (link: string) => {
      navigate(link);
    },
    [navigate],
  );

  const activeCategory = CATEGORIES[activeTab];

  return {
    activeTab,
    activeCategory,
    handleTabChange,
    handleNavigate,
  };
};
